import React from 'react';

function ErrorState({ error, onRetry }) {
  return (
    <div 
      className="mt-8 p-6 rounded-lg"
      style={{
        backgroundColor: 'hsl(var(--gb-danger-surface))',
        border: '2px solid hsl(var(--gb-danger-border))'
      }}
    >
      <h3 
        className="text-lg font-semibold mb-2"
        style={{ color: 'hsl(var(--gb-danger-border))' }}
      >
        Analysis Failed
      </h3>
      <p 
        className="text-sm mb-4"
        style={{ color: 'hsl(var(--gb-rust))' }}
      >
        {error}
      </p>
      <button
        data-testid="retry-button"
        onClick={onRetry}
        className="px-6 py-2 rounded-lg text-sm font-medium"
        style={{
          backgroundColor: 'hsl(var(--gb-danger-border))',
          color: 'white'
        }}
      >
        Retry Analysis
      </button>
    </div>
  );
}

export default ErrorState;
